// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__Zrzoz","editWrapper":"Heading_editWrapper__mV9L2","subheading":"Heading_subheading__-+6YI"};